<template>
  <div
    class="pe-card flex flex-col rounded-lg my-auto text-black  dark:text-neutral-100"
    :class="{'bg-[#F5F6F8] dark:bg-neutral-800 shadow-md'  : !noBackground }"
  >
    <div v-if="hasHeader" class="pe-card--header" :class="{ 'px-6': !noPadding }">
      <slot name="header"><div class="my-0 py-4 text-xl" v-html="header"></div></slot>
    </div>
    <div class="pe-card--body mx-4 lg:mx-6 flex-grow">
      <div
        v-if="hasHeader"
        class="-mx-4 lg:-mx-6 border-0 border-t border-b-2 border-solid border-t-[#E1E2E4] dark:border-t-neutral-600 border-b-white dark:border-b-neutral-600 shadow-[0_0_2px_rgba(0,0,0,0.1)]"
      />
      <slot></slot>
      <div
        v-if="hasFooter"
        class="-mx-4 lg:-mx-6 border-0 border-t border-b-2 border-solid border-t-[#E1E2E4] dark:border-t-neutral-600 border-b-white dark:border-b-neutral-600 shadow-[0_0_2px_rgba(0,0,0,0.1)]"
      />
    </div>
    <div v-if="hasFooter" class="pe-card--footer" :class="{ 'px-6': !noPadding }">
      <slot name="footer">{{ footer }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'

const props = defineProps<{
  header?: string
  footer?: string
  noPadding?: boolean
  noBackground?: boolean
}>()
const slots = useSlots()

const hasHeader = computed(() => !!slots.header || !!props.header)
const hasFooter = computed(() => !!slots.footer || !!props.footer)
</script>

<style lang="scss" scoped></style>
